import React, { Component } from "react"
import { defineMessages, injectIntl } from "react-intl"
import CalendarSelect from "../../../../calendar/calendarselect.component.jsx"
import DeprecatedUserSelect from "../../../../common/user/selection.component.jsx"
import CustomerSelect from "../../../../customer/selection.component.jsx"
import ConversationStatusSelect from "../../../../inbox/conversationstatusselect.component.jsx"
import IntegrationSelect from "../../../../integration/integrationSelect.component.jsx"
import ImportStatusSelect from "../../../../inventory/components/ImportStatusSelect"
import SelectComponent from "../../../../inventory/components/SelectComponent"
import CreditMemoStatusSelect from "../../../../invoice/credit-memo/CreditMemoStatusSelect"
import InvoiceStatusSelect from "../../../../invoice/statusesselection.component.jsx"
import LocationSelect from "../../../../location/locationselect.component.jsx"
import OrderStatusSelect from "../../../../order/statusesselection.component.jsx"
import PaymentTermSelect from "../../../../payment-term/locationselect.component.jsx"
import GenericPaymentTypeSelectComponent from "../../../../payment-type/form/GenericPaymentTypeSelectComponent"
import Payment3DSStatusSelect from "../../../../payment/components/payment3DSStatusSelect"
import PaymentSourceSelect from "../../../../payment/components/paymentSourceSelect"
import PaymentStatusSelect from "../../../../payment/components/paymentStatusSelect"
import PriceListStatusSelect from "../../../../price-list/statusesselection.component.jsx"
import RowCustomStatusSelectComponent from "../../../../pricing/rowcustomstatus/component/RowCustomStatusSelectComponent"
import QuoteStatusSelect from "../../../../quote/statusesselection.component.jsx"
import CalendarEventStatusSelect from "../../../../scheduling-page/calendareventstatusselect.component.jsx"
import SchedulingPageStatusSelect from "../../../../scheduling-page/statusesselection.component.jsx"
import ContactTypeSelect from "../../../contact/contactTypeSelect.component.jsx"
import MultiCurrencySelect from "../../../currency/multiselect.component.jsx"
import LabelSelect from "../../../label/selection.component.jsx"
import TaxSelect from "../../../pricing/taxselect.component.jsx"
import ProductSelect from "../../../product-selection/selection.component.jsx"
import DeclinedQuoteReason from "../../others/declinedQuoteReason.component.jsx"

const messages = defineMessages({
    isNotOneOf: {
        id: "common.search_filter.operation.isNotOneOf",
        defaultMessage: "is not one of"
    },
    isOneOf: {
        id: "common.search_filter.operation.isOneOf",
        defaultMessage: "is one of"
    }
})

class SelectFilter extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            operation: props.op || "isOneOf",
            value: props.value || []
        }
        this.returnFilter = this.returnFilter.bind(this)
        this.onChangeSelectFilter = this.onChangeSelectFilter.bind(this)
        this.onChangeSelectOp = this.onChangeSelectOp.bind(this)
    }

    //labels is a string
    onChangeSelectFilter(value, labels) {
        this.setState({ value: value })

        if ((Array.isArray(value) && value.length < 1) || !value) {
            this.props.onChangeValues("remove", this.props.id, "")
        } else {
            this.props.onChangeValues("add", this.props.id, value, labels, this.state.operation)
        }
    }

    onChangeSelectOp(event) {
        let aux = event.target.value.split("-")
        this.setState({ value: "", operation: aux[1] })
        this.props.onChangeValues("remove", this.props.id, "")
    }

    returnFilter() {
        switch (this.props.type) {
            case "user-select":
                return (
                    <DeprecatedUserSelect
                        placeholder={this.props.placeHolder}
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )

            case "label-select":
                return (
                    <LabelSelect
                        type={this.props.filterElement.labelType}
                        multi={true}
                        name={this.props.filterElement.labelName}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )

            case "location-select":
                return (
                    <LocationSelect
                        value={this.state.value}
                        multi={true}
                        optionForAll={false}
                        onChange={this.onChangeSelectFilter}
                    />
                )

            case "order-status-select":
                return (
                    <OrderStatusSelect
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )

            case "recurring-status-select":
                return (
                    <InvoiceStatusSelect
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        recurring={true}
                        onChange={this.onChangeSelectFilter}
                    />
                )

            case "invoice-status-select":
                return (
                    <InvoiceStatusSelect
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )
            case "stock-document-status-select":
                return (
                    <SelectComponent
                        multi={true}
                        customStatusIds={this.state.value}
                        onStatusChange={this.onChangeSelectFilter}
                    />
                )
            case "credit-memo-status-select":
                return (
                    <CreditMemoStatusSelect
                        multi={true}
                        onChange={this.onChangeSelectFilter}
                    />
                )
            case "stock-import-status-select":
                return (<ImportStatusSelect
                    multi={true}
                    value={this.state.value}
                    onChange={this.onChangeSelectFilter}
                />)
            case "payment-status-select":
                return (
                    <PaymentStatusSelect
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )
            case "payment-source-select":
                return (
                    <PaymentSourceSelect
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )
            case "payment-3ds-status-select":
                return (
                    <Payment3DSStatusSelect
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )
            case "return-status-select":
                return (
                    <InvoiceStatusSelect
                        isReturn={true}
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )
            case "conversation-status-select":
                return (
                    <ConversationStatusSelect
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )

            case "payment-type-select":
                return (
                    <GenericPaymentTypeSelectComponent
                        selectedPaymentTypeIds={Array.isArray(this.state.value) ? this.state.value : [this.state.value]}
                        onChange={(selectedPaymentTypeIds, selectedPaymentTypeLabels) => {
                            this.onChangeSelectFilter(selectedPaymentTypeIds, selectedPaymentTypeLabels)
                        }}
                        multi={true}
                        clearable={true}
                    />
                )
            case "tax-select":
                return (
                    <TaxSelect
                        allTaxes={true}
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        mainTaxesOnly={false}
                        clearable={false}
                    />
                )
            case "integration-select":
                return (
                    <IntegrationSelect
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                    />
                )

            case "paymentTerm-select":
                return (
                    <PaymentTermSelect
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={false}
                    />
                )

            case "currency-select":
                return (
                    <MultiCurrencySelect
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={false}
                    />
                )

            case "contactType-select":
                return (
                    <ContactTypeSelect
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={false}
                    />
                )

            case "customer-select":
                return (
                    <CustomerSelect
                        onlyLabel={true}
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={true}
                    />
                )
            case "supplier-select":
                return (
                    <CustomerSelect
                        onlyLabel={true}
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={true}
                        contactType={"suppliers"}
                    />
                )
            case "organization-select":
                return (
                    <CustomerSelect
                        onlyLabel={true}
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={true}
                        contactType={"organizations"}
                    />
                )
            case "product-select":
                return (
                    <ProductSelect multi={true} value={this.state.value} onChange={this.onChangeSelectFilter} clearable={true} />
                )

            case "product-label-select":
                return <LabelSelect multi={true} value={this.state.value} onChange={this.onChangeSelectFilter} clearable={true} />

            case "quote-status-select":
                return (
                    <QuoteStatusSelect
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={true}
                    />
                )

            case "pricelist-status-select":
                return (
                    <PriceListStatusSelect
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={true}
                    />
                )
            case "declined-quote-reason":
                return (
                    <DeclinedQuoteReason
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={true}
                    />
                )

            case "scheduling-page-status-select":
                return (
                    <SchedulingPageStatusSelect
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={true}
                    />
                )
            case "calendar-select":
                return (
                    <CalendarSelect multi={true} value={this.state.value} onChange={this.onChangeSelectFilter} clearable={true} />
                )
            case "calendar-event-status-select":
                return (
                    <CalendarEventStatusSelect
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={true}
                    />
                )
            case "product-vendor-select":
                return (
                    <LabelSelect
                        multi={true}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        clearable={true}
                        type={"vendor"}
                    />
                )
            case "order-status-select-item-report":
                return (
                    <OrderStatusSelect
                        multi={true}
                        placeholder={this.props.placeHolder}
                        value={this.state.value}
                        onChange={this.onChangeSelectFilter}
                        isItemReport={true}
                    />
                )
            case "row-custom-status":
                return (
                    <RowCustomStatusSelectComponent
                        multi={true}
                        value={this.state.value}
                        onChangeCallback={this.onChangeSelectFilter}
                    />
                )
        }
    }
    render() {
        return (
            <div className="panel panel-default card">
                <select
                    className="form-control mb-2"
                    name="operation-select"
                    value={this.props.id + "-" + this.state.operation}
                    onChange={this.onChangeSelectOp}
                    id={this.props.id + "-op"}
                >
                    <option value={this.props.id + "-isOneOf"}>{this.props.intl.formatMessage(messages["isOneOf"])}</option>
                    <option value={this.props.id + "-isNotOneOf"}>{this.props.intl.formatMessage(messages["isNotOneOf"])}</option>
                </select>

                {this.returnFilter()}
            </div>
        )
    }
}
export default injectIntl(SelectFilter)



// WEBPACK FOOTER //
// ./src/common/search-filter/filters-type/types/selectFilter.component.jsx